import { render, staticRenderFns } from "./RoomFile.vue?vue&type=template&id=4a14f88e&scoped=true&"
import script from "./RoomFile.vue?vue&type=script&lang=js&"
export * from "./RoomFile.vue?vue&type=script&lang=js&"
import style0 from "./RoomFile.vue?vue&type=style&index=0&id=4a14f88e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a14f88e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
